export interface SystemNotification {
    id: number;
    message: string;
    notificationType: number;
    validFrom: Date;
    validTo: Date;
}
